export const FETCH_RIS_WITH_MIP = "[ADMIN] FETCH_RIS_WITH_MIP";
export const FETCH_RIS_WITH_MIP_START = "[ADMIN] FETCH_RIS_WITH_MIP_START";
export const FETCH_RIS_WITH_MIP_SUCCESS = "[ADMIN] FETCH_RIS_WITH_MIP_SUCCESS";
export const FETCH_RIS_WITH_MIP_ERROR = "[ADMIN] FETCH_RIS_WITH_MIP_ERROR";

export const FETCH_ALL_RIS_USERS = "[ADMIN] FETCH_ALL_RIS_USERS";
export const FETCH_ALL_RIS_USERS_START = "[ADMIN] FETCH_ALL_RIS_USERS_START";
export const FETCH_ALL_RIS_USERS_SUCCESS = "[ADMIN] FETCH_ALL_RIS_USERS_SUCCESS";
export const FETCH_ALL_RIS_USERS_ERROR = "[ADMIN] FETCH_ALL_RIS_USERS_ERROR";



export const fetchRisWithMips = () => {
    return {
        type: FETCH_RIS_WITH_MIP
    }
}

export const fetchAllRis = () => {
    return {
        type: FETCH_ALL_RIS_USERS
    }
}

export const fetchAllRisSuccess = (ris) => {
    return {
        type: FETCH_ALL_RIS_USERS_SUCCESS,
        ris: ris
    };
};

export const fetchAllRisError = (error) => {
    return {
        type: FETCH_ALL_RIS_USERS_ERROR,
        error: error
    };
};